
/*
 * @Author: Luis duchanglong@frippler.com
 * @Date: 2022-07-20 10:17:15
 * @LastEditors: Luis duchanglong@frippler.com
 * @LastEditTime: 2022-08-15 10:54:39
 * @FilePath: \mes-web\src\api\pm\taskApi.js
 * @Description: 任务api
 */
import pmRequest from "@/utils/pmRequest";
/**
 * @desc: 列表、甘特
 * @param {*} params
 * @return {*}
 */
export function getTaskDataApi (params) {
  return pmRequest({
    url: "/pm/task/getAllProjectListTask",
    method: "get",
    params
  });
}

export function postTaskApi (data) {
  return pmRequest({
    url: "/pm/task/postTask",
    method: "post",
    data
  });
}
export function updateTaskApi (data) {
  return pmRequest({
    url: "/pm/task/postTask",
    method: "post",
    data
  });
}

export function sortTaskApi (data) {
  return pmRequest({
    url: "/pm/task/sortTask",
    method: "post",
    data
  });
}

export function getTaskDetailApi (params) {
  return pmRequest({
    url: "/pm/task/getTaskDetail",
    method: "get",
    params
  });
}

export function deleteTaskApi (data) {
  return pmRequest({
    url: "/pm/task/deleteTask",
    method: "post",
    data
  });
}

export function getTaskCommentApi (params) {
  return pmRequest({
    url: "/pm/project/task/comment",
    method: "get",
    params
  });
}
/**
 * @desc: 卡片列表
 * @param {*} params
 * @return {*}
 */
export function getAllProjectCardTaskApi (params) {
  return pmRequest({
    url: "/pm/task/getAllProjectCardTask",
    method: "get",
    params
  });
}

export function getMyCalendarApi (params) {
  return pmRequest({
    url: "/pm/task/getMyCalendar",
    method: "get",
    params
  });
}


export function getMyDailyTaskApi (params) {
  return pmRequest({
    url: "/pm/task/getMyDailyTask",
    method: "get",
    params
  });
}






